// Replaces default_pagination's numbered page links with a "Load more"
// button that fetches the next page's grid via the Section Rendering API
// and appends it in place, so browsing a few-hundred-item collection
// doesn't mean clicking through ten pages of "1 2 3 4 ... Next »".
class CollectionLoadMore extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.grid = this.querySelector('[data-collection-grid]');

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-load-more]');
      if (button) this.loadMore(button);
    });
  }

  async loadMore(button) {
    const nextUrl = button.dataset.nextUrl;
    if (!nextUrl) return;

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = button.dataset.loadingText || 'Loading…';

    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);

      const response = await fetch(url.toString());
      const text = await response.text();
      const parsed = new DOMParser().parseFromString(text, 'text/html');

      const newItems = parsed.querySelector('[data-collection-grid]');
      if (newItems) {
        this.grid.append(...newItems.children);
      }

      const newButton = parsed.querySelector('[data-load-more]');
      if (newButton && newButton.dataset.nextUrl) {
        button.dataset.nextUrl = newButton.dataset.nextUrl;
        button.disabled = false;
        button.textContent = originalText;
      } else {
        button.remove();
      }
    } catch (error) {
      button.disabled = false;
      button.textContent = originalText;
    }
  }
}

customElements.define('collection-load-more', CollectionLoadMore);
